import React from "react";
import { Typography } from "@mui/material";
import { useUplift } from "./upliftCallback";
//ts@ignore
import InfoIcon from '../../assets/icons/Icon-info-circle.svg';


interface UpliftTooltipProps {
    forceUpdate: number;
    handleMouseOver: (event: React.MouseEvent<HTMLSpanElement>) => void;
    handleMouseOut: (event: React.MouseEvent<HTMLSpanElement>) => void;
  }
  

const UpliftTooltip: React.FC<UpliftTooltipProps> = ({ forceUpdate, handleMouseOver, handleMouseOut }) => {
  const { disable } = useUplift();

  return (
    <Typography
      component={"span"}
      data-up-error=""
      className={`${!disable ? "upliftErrorHide d-none" : "Booking_payPrice displayFlex"}`}
    >
      Not Available
      <span
        className="upliftErrorTooltip"
        key={forceUpdate}
        data-up-tooltip=""
        onMouseUp={handleMouseOver}
        onMouseDown={handleMouseOut}
      >
        <img src={InfoIcon} className="Tb_upliftBookingIcon" alt="Info" />
      </span>
    </Typography>
  );
};

export default UpliftTooltip;